module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/mc-a9686e45f2982de68da3533413163aef.svg";